// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1ou_D","title":"InfoRow_title__sXa98"};